/**
 * MIRA Skeleton Component
 * Wraps Shadcn Skeleton with MIRA design system styles
 */

import React from 'react';
import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/feedback/skeleton.module.css';

export const Skeleton = ({ className, ...props }) => {
  return (
    <ShadcnSkeleton
      className={cn(styles.miraSkeleton, className)}
      {...props}
    />
  );
};

Skeleton.displayName = 'MiraSkeleton';
